module.exports = __webpack_public_path__ + "img/symbol_5.d83cfcd5.png";